import AbstractElement from "./pages/AbstractElement";
import {ViewEvent} from "./event/EventStaus";
import * as EventEmitter from "eventemitter3";


class ScrollContainer {
    readonly _template: JQuery<Window>;
    public emitter: EventEmitter;

    constructor(template: JQuery<Window>) {
        this._template = template;
        this.emitter = new EventEmitter();
        this.init();
    }

    init(): void {
        this.template.on('scroll', e => {
            const scrollTop = $('html').scrollTop() || $('body').scrollTop();
            this.emitter.emit(ViewEvent.ON_SCROLL, {scrollTop: scrollTop});
        });
    }

    get template(): JQuery<Window> {
        return this._template;
    }
}

export default ScrollContainer;